import { render, staticRenderFns } from "./LdRegistrationFailedA2pBanner.vue?vue&type=template&id=397a43e0"
import script from "./LdRegistrationFailedA2pBanner.vue?vue&type=script&lang=js"
export * from "./LdRegistrationFailedA2pBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports